
/*
 * @Author: your name
 * @Date: 2021-06-23 10:00:11
 * @LastEditTime: 2022-12-22 16:14:27
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\utils\constants.js
 */
// bjTable里的表格最大高度 的最小值
export const BJ_TABLE_MINI_HEIGHT = 240;
// 售后的类型：  1-仅退款单 2- 退货退款
export const PAGE_SIZES = [20, 30, 50, 100, 200, 500, 1000];
// 售后的类型：  1-仅退款单 2- 退货退款
export const AFTER_ORDER_TYPES = {
  REFUND_ONLY: 1,
  REFUND_GOODS: 2,
};
// 商品中心-属性来源
export const GOODS_ATTRIBUTE_SOURCES_JSON = {
  SPU: 0, // 新增（分类属性 或 商品属性）
  SYS: 1, // 系统默认
  CLASSIFY: 2, // 复制上级 分类属性
  ATTACHED: 3, // 附加属性
};

// 输入框 max 长度
export const MAX_LENGTH = {
  CODE: 6, // 验证码
  MINITEXT: 8,
  SHORT_NAME: 10, // 短短的名称
  SMALLTEXT: 32,
  DEFAULT: 50,
  NORMAL: 64,
  NORMAL_REMARK: 99,
  REMARK: 256, // 备注、描述、说明等
  BILLMAX: 400,
  PRIORITY: 999, // 优先级
  MAX: 9999, // 工单备注
};
// 商品类型 实物、虚拟
export const GOODS_TYPES = {
  REAL: 1,
  VIRTUAL: 2,
};
// 属性关联类型
export const ATTRIBUTE_RELATION_TYPES = {
  CLASSIFY: 1,
  GOODS: 2,
};
// ：执行器注册到服务的方式，包括自动注册和手动录入
export const EXECUTOR_TYPE_JSON = {
  AUTO: 0,
  MANUAL: 1,
};
// 表单类型
export const INPUT_BOX_TYPE_JSON = {
  RADIO: 1,
  CHECKBOX: 2,
  INPUT: 3,
  SELECT: 4,
};
/** ***************** ARRAY 与 JSON 分界线 ****************** */
const F = ar => {
  const a = [];
  new Map(ar).forEach((value, key) => {
    a.push({
      label: value,
      value: key,
    });
  });
  return a;
};
export const STATUS_ENABLED_NUM = F([
  [0, 'disableText'],
  [1, 'enableText'],
]);
export const HIDE_STATUS_ENABLED_NUM = F([
  [0, 'enableText'],
  [1, 'disableText'],
]);
export const STATUS_ENABLED_TRUE = F([
  [false, 'disableText'],
  [true, 'enableText'],
]);
export const STATUS_CREDITNOE_TRUE = F([
  [true, 'creditone'],
  [false, 'credittwo'],
]);
export const STATUS_ENABLED_TRUES = F([
  [1, 'disableTexts'],
  [2, 'enableTexts'],
]);

export const LANG_TYPE_LIST = F([
  ['zh', 'zh'],
  ['en', 'en'],
]);
export const SYS_ONL_NTF = F([
  [0, 'publishedText'],
  [2, 'BillingStatusSTOP'],
  [1, 'BillingStatusDRAFT'],
]);
export const STATUS_FROZEN_TRUE = F([
  [true, 'FrozenText'],
  [false, 'UnfrozenText'],
]);
export const STATUS_SKU = F([
  [0, '待生产'],
  [1, '补单中'],
  [2, '已完成']
]);
export const STATUS_RATE_CALCULATOR = F([
  [0, 'processingText'],
  [1, 'completedText'],
  [2, 'canceledText']
]);
export const STATUS_YES_NUM = F([
  [0, 'noText'],
  [null, 'noText'],
  [1, 'yesText'],
]);
export const STATUS_YES_NUMBER = F([
  [0, 'noText'],
  [1, 'yesText'],
]);
export const USE_FLAG_NUM = F([
  [0, 'notUsedText'],
  [1, 'usedText'],
]);
export const STATUS_YES_TRUE = F([
  [true, 'yesText'],
  [false, 'noText'],
]);
export const STATUS_EXITED_USER = F([
  [0, 'noText'],
  [1, 'ExitedText'],
]);
export const ITEM_TYPE_CHOOSE = F([
  ['item', 'itemText'],
  // ['package box', 'packageText'],
]);
export const PURCHASE_TYPE_NUMBER = F([
  [1, 'auPurchaseTypeText'],
  [2, 'ukPurchaseTypeText'],
]);
export const OPTTYPE_LIST = F([
  ['System', 'SystemText'],
  ['Manual', 'ManualText'],
]);
export const BILLING_PAGE_STATUS = F([
  ['PREVIEW', 'BillingStatusPREVIEW'],
  ['UNPAID', 'BillingStatusUNPAID'],
  ['PARTIAL', 'BillingStatusPARTIAL'],
  ['PAID', 'BillingStatusPAID'],
  ['OVERPAID', 'BillingStatusOVERPAID'],
]);
export const BILLING_CATEGORI_STATUS = F([
  ['Draft', 'BillingStatusDRAFT'],
  ['Running', 'BillingStatusRUNNING'],
  ['Stop', 'BillingStatusSTOP'],
]);
export const BILLING_CATEGORI_TYPE = F([
  ['Normal', 'BillingStatusNormal'],
  ['Range', 'BillingStatusRange'],
]);
export const BILLING_CATEGORI_REPORTGROUP = F([
  ['Normal', 'BillingStatusNormal'],
  ['Section', 'BillingStatusSection'],
]);
export const BILLING_DEPOSIT_STATUS = F([
  ['Pending', 'PendingText'],
  ['Received', 'ReceivedText1'],
  ['Cancelled', 'canceledText'],
  ['Declined', 'DeclinedText1'],
]);
export const BILLING_DEPOSIT_STATUS_ALL = F([
  ['ALL', 'allText'],
  ['Pending', 'PendingText'],
  ['Received', 'ReceivedText1'],
  ['Declined', 'DeclinedText1'],
]);
export const STATUS_HAVE_TRUE = F([
  [false, 'notHaveText'],
  [true, 'haveText'],
]);
export const STATUS_INIT_LIST = F([
  [0, 'notInitializedText'],
  [1, 'initializedText'],
]);
export const GENDER_LIST = F([
  [0, 'manText'],
  [1, 'womanText'],
]);
export const GOODS_TYPE_LIST = F([
  [1, 'physicalGoodsText'],
  [2, 'virtualGoodsText'],
]);
// -商品中心-商品管理- 组合类型 (普通商品、组合商品、子母件)
export const GOODS_COMBO_TYPES = {
  ORDINARY: 0,
  PACKAGE: 1,
  SON: 3,
};
export const GOODS_COMBO_TYPES_CSG = {
  ORDINARYCSG: 0,
  PACKAGE: 1,
};

export const GOODS_COMBO_TYPE_LIST = F([
  [0, 'generalMerchandiseText'],
  [1, 'packageItemText'],
]);
export const ORDER_WMS_STATUS_LIST = F([
  // [-1, 'ThreePartySalesOrder.OnHold'],
  [0, 'CancellingText'],
  [1, 'cancelSuccessfulText'],
  [2, 'cancelFailedText'],
  [3, 'EditingText'],
  [4, 'editSuccessfulText'],
  [5, 'editFailedText'],
  [6, 'CancellingText'],
]);
export const LANG_ZH_EN_PS_LIST = F([
  ['商品匹配异常', 'matchingAnomalyText'],
  ['商品尺寸异常', 'sizeAnomalyText'],
  ['收件地址匹配异常', 'addressAnomalyText'],
  ['下单时间异常', 'timeAnomalyText'],
  ['收货地址异常', 'addressAnomalyText'],
  ['收件地址异常', 'addressAnomalyText'],
  ['单价异常', 'priceAnomalyText'],
  ['收件人手机号异常', 'phoneAnomalyText'],
  ['收件人信息异常', 'informationAnomalyText'],
  ['平台/供应商异常', 'supplierAnomalyText'],
  ['税号异常', 'taxAnomalyText'],
  ['账户号异常', 'AccountAnomalyText'],
  ['货币异常', 'CurrencyAnomalyText'],
  ['项目异常', 'ItemAnomalyText'],
  ['店铺匹配异常', 'StoreAnomalyText'],
  ['买家备注待客服审核', 'BuyerNotesText'],
  ['批次库存不足', 'BuyerSTOCKText'],
  ['POBox超长超重', 'BuyerSTOCKPOText'],
  ['国际订单需提供HS Code 原产地 成本价', 'BuyerHSCodeText'],
  ['Pickup 类型订单不允许填写收货地址', 'BuyerPickupText'],
  ['SKU尺寸异常', 'SKUDimensionText'],
  ['收件地址异常（超过40字符）', 'AddressExceptionText'],
]);
// 商品中心-SKU-完整状态
export const GOODS_SKU_STATUS = F([
  [0, 'roughDraftText'],
  [[1, 5], 'rejectedText'],
  [[2, 4], 'underReviewText'],
  [[3], 'effectiveText'],
]);
// 商品中心-SKU-状态 对应为 审核状态
export const GOODS_SKU_VIEW_AUDIT_STATUS = F([
  [0, 'notSubmittedReviewText'],
  [1, 'rejectedText'],
  [2, 'underReviewText'],
  [3, 'completedText'],
  [4, 'underReviewText'],
  [5, 'rejectedText'],
]);
/** * 审核列表  对应 GOODS_SKU_STATUS */
// 默认： 1 2 3 4 5
// tobeReviewedText: 2 4
// 已生效 3
// rejectedText 1 5
export const GOODS_AUDIT_STATUS_LIST = F([
  [[2, 4], 'tobeReviewedText'],
  [[3], 'completedText'],
  [[1, 5], 'rejectedText'],
]);
// 商品中心-SKU-状态（无草稿）
export const GOODS_SKU_STATUS_NORMAL = GOODS_SKU_STATUS.slice(1);
// 价格项，固定值;   'JG004', '内部分摊价'
export const GOODS_PRICE_ITEMS = F([
  ['costPrice', 'costPriceText'],
  ['salesPrice', 'salesPriceText'],
  ['activityPrice', 'activityPriceText'],
  ['marketPrice', 'marketPriceText'],
  ['distributionPrice', 'distributionPriceText'],
  ['wholesalePrice', 'tradePriceText'],
  ['clearingPrice', 'settlementPriceText'],
]);
// 状态：
// 事务实例的运行状态。     共有进行中、完成、失败、没有消费者四种状态。
// 事务实例时任务的运行状态。共有进行中、完成、失败、队列中、等待被拉取五种种状态。
export const INSTANCE_RESULT_TYPE_LIST = F([
  ['RUNNING', 'haveInHandText'],
  ['FAILED', 'failedText'],
  ['COMPLETED', 'completedText'],
  ['NON_CONSUMER', 'noConsumersText'],
  ['WAIT_TO_BE_PULLED', 'waitingToBepulledText'],
]);
// 存储类型
export const FILE_STORAGE_TYPE_LIST = F([
  [1, 'AlibabaCloudText'],
  [2, 'HuaweiCloudText'],
  [3, 'Minio'],
  [4, 'TencentCloudText'],
  [5, 'QiniuCloudText'],
  [6, 'LocalText'],
  [7, 'JDCloudText'],
  [8, 'AWS'],
  [9, 'BaiduCloudText'],
]);
// ：执行器注册到服务的方式，包括自动注册和手动录入
export const EXECUTOR_TYPE_LIST = F([
  [0, 'automaticLogonText'],
  [1, 'manualEntryText'],
]);
export const INPUT_BOX_TYPE_LIST = F([
  [1, 'radioText'],
  [2, 'checkBoxText'],
  [3, 'textBoxText'],
  [4, 'dropdownBoxText'],
]);
export const INDEXES_TYPE_LIST = F([
  [0, 'loseEfficacyText'],
  [1, 'efficacyText'],
]);
export const FIELD_TYPE_LIST = F([
  [0, 'positiveSequenceText'],
  [1, 'invertedOrderText'],
]);
export const RADIX_POINT_COMPUTED_MODE_LIST = F([
  ['trunc', 'roundDownText'],
  ['plusOne', 'roundUpText'],
]);
export const SHOP_TYPE_LIST = F([
  ['OnlineShop', 'onlineStoreText'],
  ['PhysicalShop', 'storeText'],
]);
export const PACKAGE_TYPE_LIST = F([
  ['order', 'goodsPage.package.order'],
  ['product', 'goodsPage.package.product'],
]);
export const CODE_RULE_FIELD_TYPE_LIST = F([
  ['SEQUENCE', 'orderText'],
  ['CONSTANT', 'constantText'],
  ['DATE', 'dateText'],
  ['VARIABLE', 'variableText'],
  ['UUID', 'UUID'],
]);
export const UUID_LEN_LIST = F([
  [8, '8-bit'],
  [16, '16-bit'],
  [22, '22-bit'],
  [32, '32-bit'],
]);
/** 取自 STOCK.WAREHOUSE_TYPE 的子集*/
export const STOCK_WAREHOUSE_TYPE_SON_1_LIST = F([
  ['interline-virtual', 'transferVirtualWarehouseText'],
  ['ratio-virtual', 'proportionalVirtualWarehouseText'],
  ['qty-virtual', 'quantityVirtualWarehouseText'],
]);
/** 取自 STOCK.WAREHOUSE_TYPE 的子集*/
export const STOCK_WAREHOUSE_TYPE_SON_2_LIST = F([
  ['interline-virtual', 'transferVirtualWarehouseText'],
  ['ratio-virtual', 'proportionalVirtualWarehouseText'],
  ['qty-virtual', 'quantityVirtualWarehouseText'],
  ['default-virtual', 'defaultVirtualWarehouseText'],
  ['real', 'solidWarehouseText'],
  ['logic', 'logicalWarehouseText'],
]);
/** 取自 STOCK.WAREHOUSE_TYPE 的子集*/
export const STOCK_WAREHOUSE_TYPE_SON_3_LIST = F([
  ['qty-virtual', 'quantityVirtualWarehouseText'],
  ['interline-virtual', 'transferVirtualWarehouseText'],
]);
/** 取自 STOCK.WAREHOUSE_TYPE 的子集*/
export const STOCK_WAREHOUSE_TYPE_SON_4_LIST = F([
  ['real', 'solidWarehouseText'],
  ['ratio-virtual', 'proportionalVirtualWarehouseText'],
]);
export const REPLENISHMENT_ORDER_PRIORITY = F([
  ['order', 'orderItemShortagePriorityText'],
  ['shop', 'priorityGivenToStoreProductShortageText'],
]);
export const RELEASE_STATUS_TRUE = F([
  [false, 'notPublishedText'],
  [true, 'publishedText'],
]);

export const CONFIGURE_STATUS_TRUE = F([
  [false, 'notSetText'],
  [true, 'setText'],
]);

export const TEMPLATE_DATA_TYPE_LIST = F([
  ['VARCHAR', 'VARCHAR'],
  ['BIGINT', 'BIGINT'],
  ['DECIMAL', 'DECIMAL'],
]);

/** 取自 STOCK.RECORD_STATUS 的子集*/
export const STOCK_LOCK_STATUS_LIST = F([
  ['wait', 'tobeReviewedText'],
  ['success', 'auditSucceededText'],
  ['fail', 'auditFailedText'],
  ['abandon', 'voidedText'],
  ['close', 'deactivateText'],
]);
/** 取自 STOCK.RECORD_STATUS 的子集*/
export const STOCK_TRANSFER_VERIFY_TYPE_LIST = F([
  ['wait', 'tobeReviewedText'],
  ['success', 'auditSucceededText'],
  ['fail', 'auditFailedText'],
]);
/** 取自 STOCK.RECORD_STATUS 的子集*/
export const STOCK_DISTRIBUTION_PLAN_STATUS_LIST = F([
  ['start', 'openText'],
  ['stop', 'suspendText'],
  ['complete', 'completedText'],
  ['endTime', 'deadlineText'],
]);
export const VIRTUAL_GOODS_ROUTE_LIST = F([
  ['BusinessGoodsVirtualSkuGroupList', '组合商品'],
  ['BusinessGoodsVirtualSpuSonList', '子母件商品'],
  ['BusinessGoodsVirtualInstallServiceList', '安装服务'],
]);

export const STOCK_DELIVERY_ROUTE_LIST = F([
  ['BusinessStockDeliveryInformIndex', '出库通知单'],
  ['BusinessStockDeliveryResultIndex', '出库结果单'],
]);

export const STOCK_TRANSFER_ROUTE_LIST = F([
  ['BusinessStockTransferLogicIndex', '逻辑仓调拨'],
  ['BusinessStockTransferVirtualIndex', '虚仓移仓'],
]);

export const STOCK_VERIFY_ROUTE_LIST = F([
  ['BusinessStockVerifyLogicIndex', '逻辑仓调拨'],
  ['BusinessStockVerifyVirtualIndex', '虚仓移仓'],
  ['BusinessStockVerifyLockIndex', '库存预留'],
]);
export const STOCK_DISTRIBUTION_ROUTE_LIST = F([
  ['BusinessStockDistributionQtyIndex', '仓位数量分配'],
  ['BusinessStockDistributionRatioIndex', '仓位比例分配'],
  ['BusinessStockDistributionPlanIndex', '分仓计划'],
]);
export const LOGISTICS_COMPANY_ROUTE_LIST = F([
  ['BusinessLogisticsCompanyListIndex', '物流商列表'],
  ['BusinessLogisticsCompanyBusinessIndex', '物流业务管理'],
  ['BusinessLogisticsCompanyPostCodeIndex', '邮编管理'],
  // ['BusinessLogisticsCompanyRelationIndex', '运费关联设置'],
  // ['BusinessLogisticsCompanyFreightIndex', '运费模板'],
  // ['BusinessLogisticsCompanyMapping', '物流映射'],
]);
export const ORDER_ABNORMAL_FIVE_ROUTE_LIST = F([
  ['BusinessAbnormalOrderSTOCK', '新订单'],
  ['BusinessAbnormalOrderPROCESSINGOrder', '处理中订单'],
  ['BusinessAbnormalOrderANOMALY', '异常订单'],
  ['BusinessAbnormalOrderOUTOFSTOCK', '订单缺货'],
  ['BusinessAbnormalOrderEXCEPTION', '推送异常'],
  ['BusinessAbnormalOrderTIMEOUT', '预占超时'],
  ['BusinessAbnormalOrderALL', '全部'],
  ['BusinessAbnormalOrderPendingHJCancel', '待HJ取消'],
  ['BusinessAbnormalOrderUrgent', '加急'],
  ['BusinessAbnormalOrderHUNT', '待手动取消'],
  ['OrderAllStatusCollectText', '等待取货'],
  ['OrderAllStatusCollectLabelText', '已上传面单'],
  ['BusinessAbnormalOrderWAIRING', '等待发货'],
]);
export const BILLING_PAGE_INVOICE_REPORT_LIST = F([
  ['BillingPageInvoiceReportTotal', 'Total'],
  ['BillingPageInvoiceReportPallet', 'Pallet'],
  ['BillingPageInvoiceReportCBM', 'CBM'],
  ['BillingPageInvoiceReportClientQty', 'ClientQty'],
  ['BillingPageInvoiceReportClient', 'Client'],
  ['BillingPageInvoiceReportPostage', 'Postage'],
  ['BillingPageInvoiceReportSales', 'Sales'],
]);
export const LOGISTICS_ORDER_ROUTE_LIST = F([
  ['BusinessLogisticsOrderSale', '销售单物流'],
  ['BusinessLogisticsOrderAfter', '售后单物流'],
]);
export const SETTING_ORGANIZATION_ROUTE_LIST = F([
  ['SettingUserOrganizationGroup', '集团设置'],
  ['SettingUserOrganizationCompany', '下属公司'],
]);
export const LOGISTICS_ABNORMAL_ROUTE_LIST = F([
  ['BusinessLogisticsAbnormalDelivery', '派送异常'],
  ['BusinessLogisticsAbnormalDataAbort', '物流数据异常'],
]);
export const SALES_AFTER_INTERNAL_ROUTE_LIST = F([
  ['BusinessAfterInternalRefundIndex', 'RefundOnlyText'],
  ['BusinessAfterInternalReturnIndex', 'ReturnRefundText'],
  // ['BusinessAfterInternalExchangeIndex', '换货'],
]);
export const SALES_AFTER_THIRD_ROUTE_LIST = F([
  ['BusinessThirdAfterRefundIndex', 'RefundOnlyText'],
  ['BusinessThirdAfterReturnIndex', 'ReturnRefundText'],
  ['BusinessThirdAfterExchange', '换货'],
]);

export const FINANCE_PLATFORM_ROUTE_LIST = F([
  ['BusinessFinancePlatformTM', '天猫账单'],
  ['BusinessFinancePlatformJD', '京东账单'],
  ['BusinessFinancePlatformPDD', '拼多多账单'],
  ['BusinessFinancePlatformDY', '抖音账单'],
  ['BusinessFinancePlatformWPH', '唯品会账单'],
  ['BusinessFinancePlatformSNYG', '苏宁账单'],
  ['BusinessFinancePlatformXMYP', '小米账单'],
  ['BusinessFinancePlatformWYYX', '网易账单'],
]);
/** 物流商状态值集 */
export const LOGISTICS_CLAIM_STATUS_LIST = F([
  [0, 'tobeReviewedText'],
  [1, 'ToBeWrittenOffText'],
  [2, 'approvedText'], // 已审核
  [3, 'auditRejectText'], // 已驳回
  [4, 'canceledText'],
]);
/** 物流商状态值集 */
export const LOGISTICS_CLAIM_CLAIMTYPE_LIST = F([
  [1, 'wornText'],
  [2, 'lostPartsText'],
]);
/** 物流商状态值集 */
export const LOGISTICS_CLAIM_STANDARD_LIST = F([
  [0, 'NormalStandardSellingPriceText'],
  [1, 'internalAllocationPriceText'],
  [2, 'ExfactoryPriceText'],
]);

export const EXPRESS_STATUS_LIST = F([
  ['0', 'InTransitText'],
  ['1', 'CollectedText'],
  ['2', 'ExceptionText'],
  ['3', 'DeliveredText'],
  ['4', 'SignBackText'],
  ['5', 'OutForDeliveryText'],
  ['6', 'ReturnedText'],
  ['7', 'TransferText'],
  ['10', 'AwaitingClearanceText'],
  ['11', 'ClearanceInProgressText'],
  ['12', 'ClearedText'],
  ['13', 'ClearanceExceptionText'],
  ['14', 'visaRejectedText'],
]);
export const ABNORMAL_REASON_LIST = F([
  [1, 'freightTemplateMismatchText'],
  [2, 'logisticsMismatchText'],
  [3, 'businessMismatchText'],
]);
export const ABNORMAL_STATUS_LIST = F([
  [0, 'untreatedText'],
  [1, 'processedText'],
]);
export const PO_SHIPPINGMETHOD_STATUS_LIST = F([
  ['Container', 'ContainerText'],
  ['Pallets', 'PalletsText'],
  ['Carton', 'CartonText'],
]);
export const PO_CONTAINERTYPE_STATUS_LIST = F([
  ['Loose', 'LooseText'],
  ['Pallet', 'PalletText'],
]);
export const PO_CONTAINERLENGTH_STATUS_LIST = F([
  ['40 ft', '40 ft'],
  ['20 ft', '20 ft'],
  ['40 ft HC', '40 ft HC'],
  ['45 ft HC', '45 ft HC'],
]);
/** 运费模板 */
export const LOGISTICS_COMPANY_FREGHHT_ADD_JFFS = F([
  [1, 'billingByWeightText'],
  [2, 'fixedPriceText'],
]);
/** 运费模板 -> 理赔标准 */
export const LOGISTICS_COMPANY_COMPENSATE_LIST = F([['JG004', 'internalAllocationPriceText']]);
export const SETTING_STOCK_PROCESS_TYPES = F([
  ['订单出库', '订单出库'],
  ['下架出库', '下架出库'],
  ['采购入库', '采购入库'],
  ['退货入库', '退货入库'],
]);
export const SETTING_STOCK_PROCESS_TYPE_JSON = {
  订单出库: 'out-stock-process',
  下架出库: 'out-stock-process',
  采购入库: 'put-stock-process',
  退货入库: 'put-stock-process',
};
export const PURCHASE_TYPE = F([
  ['COMMON', 'cnPurchaseTypeText'],
  ['FREE_GIFT', 'auPurchaseTypeText'],
]);
export const PURCHASE_STATUS = F([
  ['new', 'newPurchaseStatusText'],
  ['old', 'oldPurchaseStatusText'],
]);
export const QUOTATION_TYPE = F([
  ['new', 'newQuotationTypeText'],
  ['old', 'oldQuotationTypeText'],
]);
export const RETURN_ORDER_STATUS = F([
  ['Pending', 'returnOrderStatusPendingText'],
  ['Completed', 'returnOrderStatusBackText'],
  ['Abandoned', 'returnOrderStatusAbandonedText'],
]);
export const RETURN_PRODUCT_STATUS = F([
  ['Complete', 'returnProductStatusCompleteText'],
  ['Damaged', 'returnProductStatusDamagedText'],
]);
export const EXEC_STATUS_LIST = F([
  ['1', '未执行'],
  ['2', '已执行']
]);
export const INCOMING_TYPE = F([
  ['WAIT_STOCKIN', 'waitStockInText'],
  ['ALL_STOCKIN', 'allStockInText'],
  ['SUCCESS_PUSH_SAP', 'successPushSapText'],
  ['FAIL_PUSH_SAP', 'failPushSapText'],
]);
export const ORDER_BACK_RES_LIST = F([
  ['0', 'NotWrittenBackText'],
  ['1', 'WriteBackSucceededText'],
  ['2', 'WriteBackFailedText'],
]);
export const THIRD_ORDER_RECEIVE_STATUS = F([
  ['0', 'UnreceivedGoodsText'],
  ['1', 'PartialReceiptText'],
  ['2', 'ReceivedText'],
]);
/** 补货类型 */
export const ORDER_STOCKOUT_TYPE_LIST = F([
  [0, 'OrderReplenishmentText'],
  [1, 'ShopReplenishmentText'],
]);

/**

  13-仅退款	1-一审	 1-tobeReviewedText	   31310
                    2-approvedText	31311
                    3-auditRejectText	31312
            2-二审	1-tobeReviewedText	  31320
                    2-approvedText	31321
                    3-auditRejectText	31322
14-退货退款	1-一审	 1-tobeReviewedText	   31410
                    2-approvedText	31411
                    3-auditRejectText	31412
            2-二审	1-tobeReviewedText	  31420
                    2-approvedText	31421
                    3-auditRejectText	31422

 */
export const AFTER_REFUND_AUDIT_TABS_STATUS = F([
  ['31310,31320,31312,31322', 'wholeText'],
  ['31310', 'PendingFirstTrialText'],
  ['31320', 'PendingSecondReviewText'],
  ['31312,31322', 'auditRejectText'],
]);
export const AFTER_RETURN_AUDIT_TABS_STATUS = F([
  ['31410,31420,31412,31422', 'wholeText'],
  ['31410', 'PendingFirstTrialText'],
  ['31420', 'PendingSecondReviewText'],
  ['31412,31422', 'auditRejectText'],
]);
// 仅退款的审核状态 endorseStatus
export const AFTER_REFUND_ENDORSE_STATUS = F([
  ['31310', 'PendingFirstTrialText'],
  ['31311', 'PassedInTheFirstInstanceText'],
  ['31312', 'RefusalOfFirstInstanceText'],
  ['31320', 'PendingSecondReviewText'],
  ['31321', 'PassedInTheSecondInstanceText'],
  ['31322', 'RejectionOfSecondInstanceText'],
]);
// 退货退款的审核状态 endorseStatus
export const AFTER_RETURN_ENDORSE_STATUS = F([
  ['31410', 'PendingFirstTrialText'],
  ['31411', 'PassedInTheFirstInstanceText'],
  ['31412', 'RefusalOfFirstInstanceText'],
  ['31420', 'PendingSecondReviewText'],
  ['31421', 'PassedInTheSecondInstanceText'],
  ['31422', 'RejectionOfSecondInstanceText'],
]);
export const AFTER_REFUND_AUDIT_PERMISSION_RULES = [
  // 全部
  ['BusinessAfterAuditRefund_FirstAudit', 'BusinessAfterAuditRefund_SecondAudit'],
  // 待一审
  ['BusinessAfterAuditRefund_FirstAudit'],
  // 待二审
  ['BusinessAfterAuditRefund_SecondAudit'],
  // auditRejectText
  ['BusinessOrderAuditIndex_ItIsAwayNot'],
];
export const AFTER_RETURN_AUDIT_PERMISSION_RULES = [
  // 全部
  ['BusinessAfterAuditReturn_FirstAudit', 'BusinessAfterAuditReturn_SecondAudit'],
  // 待一审
  ['BusinessAfterAuditReturn_FirstAudit'],
  // 待二审
  ['BusinessAfterAuditReturn_SecondAudit'],
  // auditRejectText
  ['BusinessOrderAuditIndex_ItIsAwayNot'],
];
/** 内部仅退款状态 */
export const AFTER_REFUND_TRADE_STATUS = F([
  ['0', 'tobeReviewedText'],
  ['3', 'ToBeRefundedText'],
  ['4', 'completedText'],
  ['5', 'RefusedText'],
  ['6', 'canceledText'],
  ['7', 'AbnormalDocumentTransferText'],
]);
export const AFTER_REFUND_TRADE_STATUS_FOR_VIEW = AFTER_REFUND_TRADE_STATUS.slice(0, 3);
/** 内部退货退款状态 */
export const AFTER_RETURN_TRADE_STATUS = F([
  ['0', 'tobeReviewedText'],
  ['1', 'ToBeReturnedByTheBuyerText'],
  ['2', 'ToBeAcceptedByTheWarehouseText'],
  ['3', 'ToBeRefundedText'],
  ['4', 'completedText'],
  ['5', 'RefusedText'],
  ['6', 'canceledText'],
  ['7', 'AbnormalDocumentTransferText'],
]);
export const AFTER_RETURN_TRADE_STATUS_FOR_VIEW = AFTER_RETURN_TRADE_STATUS.slice(0, 5);
export const AFTER_EXCHANGE_TRADE_STATUS = F([
  ['10', 'tobeReviewedText'],
  ['11', 'ToBeReturnedByTheBuyerText'],
  ['12', 'ToBeAcceptedByTheWarehouseText'],
  ['13', 'ToBeShippedFromWarehouseText'],
  ['14', 'ToBeReceivedByTheBuyerText'],
  ['15', 'completedText'],
]);
/** 业务中心/销售管理/业务预警-异常订单管理 */
export const _FIVE = F([
  ['BusinessOrderAbnormalWarning', '业务预警'],
  ['BusinessOrderAbnormalSyncAbnormal', '数据异常'],
]);
/** 预警类型  异常类型 */
export const ORDER_ABNORMAL_TYPE_LIST = F([
  [0, 'AuditTimeoutText'],
  [1, 'OutOfStockTimeoutText'],
  [2, 'DeliveryTimeoutText'],
  [3, 'OrderUpdateTimeoutText'],
]);
/** 入库单状态 */
export const STORAGE_ORDER_STATUS_LIST = F([
  ['New', 'New'],
  ['Uploaded', 'Uploaded'],
  ['Arrived', 'Arrived'],
  ['Receiving', 'Receiving'],
  ['Received', 'Received'],
  ['In Progress', 'In Progress'],
  ['UploadFail', 'UploadFail'],
]);

export const STORAGE_ORDER_STATUS_LIST2 = F([
  ['Cancelled', 'Cancelled'],
  ['Done', 'Done']
]);
/** 换货状态 */
export const AFTER_THIRD_EXCHANGE_STATUS_LIST = F([
  [0, 'tobeReviewedText'],
  [1, 'ToBeReturnedByTheBuyerText'],
  [2, 'ToBeShippedText'],
  [3, 'ToBeReceivedByTheBuyerText'],
  [4, 'completedText'],
  [5, 'BuyerCancellationText'],
  [6, 'CloseExchangeText'],
  [7, 'RefusalToExchangeGoodsText'],
]);
/** 三方售后单/ 售后状态 */
export const AFTER_INTERNAL_ORDER_LIST = F([
  [0, 'NoAfterSalesServiceText'],
  [2, 'appliesMerchantText'],
  [3, 'processedMerchantText'],
  [4, 'refundMerchantText'],
  [5, 'agreesMerchantText'],
  [6, 'rejectedMerchantText'],
  [7, 'returnMerchantText'],
  [8, 'PlatformMerchantText'],
  [9, 'refusesMerchantText'],
  [10, 'RefundSucceededText'],
  [11, 'revocationMerchantText'],
  [12, 'notprocessedMerchantText'],
  [13, 'overdueMerchantText'],
  [14, 'processingMerchantText'],
  [15, 'pendingMerchantText'],
  [16, 'successfulMerchantText'],
  [17, 'failedMerchantText'],
  [18, 'confirmedMerchantText'],
  [21, 'WaitMerchantText'],
  [22, 'shipmentMerchantText'],
  [24, 'closedMerchantText'],
  [25, 'RepairMerchantText'],
  [27, 'confirmationMerchantText'],
  [31, 'rejectMerchantText'],
  [32, 'SupplementaryMerchantText'],
]);
/** 三方售后单/ 结算方式 */
export const AFTER_INTERNAL_RETURN_PAY_LIST = F([[1, 'OnlineStorePlatformRefundText']]);
/** 三方售后单/ 转单状态 */
export const AFTER_THIRD_REFUND_TRANSFER_STATUS = F([
  [0, 'normalText'],
  [1, 'unusualText'],
]);
/** 三方售后单/ 售后类型 */
export const AFTER_THIRD_TYPE_LIST = F([
  [1, 'RefundOnlyText'],
  [2, 'ReturnRefundText'],
  // [3, '退货换货'],
  // [4, '维修'],
  // [5, '补发'],
]);
/** 三方售后单/ 售后回传状态 */
export const AFTER_THIRD_REFUND_RETURN_STATUS = F([
  [0, 'NotReturnedText'],
  [2, 'AfterSalesHasBeenReturnedText'],
]);
/** 三方售后单/ 同步物流状态 */
export const AFTER_THIRD_SYNCLOGISTICS_STATUS = F([
  [0, 'NotSynchronizedText'],
  [1, 'SynchronizedText'],
]);
/** 物流策略-设置订单金额 */
/** tobeReviewedText售后单 */
export const STRATEGY_AUTO_REPLENISH_ROUTE_LIST = F([
  ['BusinessStrategyAutoReplenishOrder', '订单商品缺货'],
  ['BusinessStrategyAutoReplenishOnlineStore', '网店商品缺货'],
]);
/** 异常库存管理 router */
export const STOCK_ABNORMAL_ROUTE_LIST = F([
  ['BusinessStockAbnormalOrder', '订单缺货'],
  ['BusinessStockAbnormalWarehouse', '仓库缺货'],
]);
/** 支付状态 */
export const STOCK_ABNORMAL_ORDER_STATUS_LIST = F([
  [0, 'PendingText'],
  [1, 'PurchasedText'],
  [2, 'TransferredText'],
  [3, 'WarehouseMovedText'],
]);
/* ************************************** 寻源策略部分 start ****************************************** */
/** 异常库存管理 router */
export const STRATEGY_SOURCE_ROUTE_LIST = F([
  // #ifndef OPEN-SOURCE
  ['SettingOrderSourceStrategySource', '寻源规则'],
  ['SettingOrderSourceStrategyParcel', '包裹规则'],
  // ['SettingOrderSourceStrategyArea', '区域规则'],
  // #endif
]);
/* ************************************** 寻源策略部分 end ****************************************** */

/* ************************************** 内部销售单 start ****************************************** */
export const SKU_GIFT_TYPE_LIST_FOR_CREATE = F([
  ['0', 'noText'],
  ['1', 'yesText'],
]);
/** 订单 —— 交易类型 tradeType */
export const ORDER_TRADE_TYPE_LIST = F([['101', 'SalesOrderText']]);
/** 订单 —— 业务类型 businessType */
export const ORDER_BUSINESS_TYPE_LIST = F([
  ['common', 'GeneralOrderText'],
  ['o2o', 'O2OOrdersText'],
]);
export const ORDER_BUSINESS_TYPES = {
  O2O: 'o2o',
  COMMON: 'common',
};
export const ORDER_QUOTE_TYPES_STATUS = F([
  [0, 'QUATEStatus0'],
  [1, 'QUATEStatus1'],
  [2, 'QUATEStatus2'],
  [3, 'QUATEStatus3'],
]);
/** 订单 —— 提货方式 takingDeliveryWay */
export const ORDER_TAKING_DELIVERY_TYPE_LIST = F([
  ['1', 'StoreSelfCollectionText'],
  ['2', 'LogisticsDistributionText'],
]);
/** 二次分拣 —— 波次列表 —— 状态 */
export const WAVE_STATUS_LIST = F([
  ['processing', 'processingText'],
  ['completed', 'completedText'],
]);
/** 用工管理 用人状态 */
export const DEPT_HOURS_HEADCOUNT_SATATUS = F([
  ['计划用人待申报', 'HEADCOUNT1'],
  ['计划用人审批中', 'HEADCOUNT2'],
  ['超用驳回', 'HEADCOUNT3'],
  ['实际用人待申报', 'HEADCOUNT4'],
  ['已完成', 'HEADCOUNT5'],
]);
/** 用工管理 加班状态 */
export const DEPT_HOURS_OVERTIME_SATATUS = F([
  ['加班计划审批中', 'OVERTIME1'],
  ['加班计划驳回', 'OVERTIME2'],
  ['加班计划已通过', 'OVERTIME3'],
]);
/** csg订单运输方式*/
export const CSG_ORDER_SHIPPING_METHODS_LIST = F([
  ['Standard Shipping', 'Standard'],
  ['Express Shipping', 'Express'],
  ['PICKUP', 'Pickup'],
  ['CSG MANUAL', 'CSG Manual Booking'],
  ['CUSTOMER MANUAL', 'Customer Manual Booking']
]);
/** 订单 —— 创建类型 / 订单来源 actionType  */
export const ORDER_ACTION_TYPE_LIST = F([
  ['101', 'OrdinaryDocumentTransferText'],
  ['201', 'ManualOrderText'],
  ['202', 'CopyOrderText'],
  ['301', 'RepeatOrderText'],
  ['302', 'ReissueOrderText'],
]);
/** 内部销售单 --> 订单聚合状态 */
export const ORDER_INTERNAL_ORDER_STATUS_LIST = F([
  ['0', 'unfinishedText'],
  ['1', 'completedText'],
  ['2', 'ClosedText'],
  ['3', 'unusualText'],
]);
/** 内部销售单 --> 订单聚合状态 -----》  CSG */
export const CSG_ORDER_INTERNAL_ORDER_STATUS_LIST = F([
  ['0', 'unfinishedText'],
  ['1', 'completedText'],
]);
/** 内部销售单 --> 订单聚合状态 -----》  CSG新 */
export const CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST = F([
  ['0', 'allOrderText'],
  ['1', 'completedOrderText'],
  ['2', 'cancelOrderText'],
]);
/** 钱包 --> 客户账户信息tab页 -----》  CSG新 */
export const CSG_CLIENTACCOUNTS_TAB_LIST = F([
  ['0', 'WalletBalance'],
  ['1', 'WalletTransaction'],
]);
/** 工单 --> 工单列表tab页 -----》  Admin端 */
export const CSG_WORK_ORDER_LIST_ADMIN_OPEN = F([
  ['0', 'wholeText'],// 全部
  ['1', 'BillingStatusDRAFT'],// 草稿
  ['2', 'ApprovalText'],// 待审批
  ['3', 'AwaitingProcessingText'],// 待处理
  ['4', 'ProgressText'],// 处理中
  ['6', 'NotApprovedText'],// 审批不通过
  ['9', 'ConfirmationPending'],// 待确认
]);
export const CSG_WORK_ORDER_LIST_ADMIN_CLOSE = F([
  ['0', 'wholeText'],// 全部
  ['5', 'CompletedText'],// 已处理
  ['7', 'CancelledText'],// 已作废
]);

// 退件列表---return
export const CSG_RETURN_LIST_ADMIN_CLOSE = F([
  [1, 'InProcessing'],
  [2, 'Waitingforreturntowarehouse'],
  [3, 'Completed'],
  [4, 'unfinishedText'],
]);
// 退件列表---return
export const CSG_RETURN_LIST_ADMIN_OPEN_STATUS = F([
  [1, 'InProcessing'],
  [2, 'Waitingforreturntowarehouse'],
  [4, 'allText'],
]);
export const CSG_RETURN_LIST_ADMIN_STATUS = F([
  ['2', 'Restocked'],
  ['3', 'TemporaryStrong'],
  ['4', 'Discard'],
]);

/** 工单 --> 工单列表tab页 -----》  User端 */
export const CSG_WORK_ORDER_LIST_USER_OPEN = F([
  ['0', 'wholeText'], // 全部
  ['1', 'BillingStatusDRAFT'], // 草稿
  ['2', 'ApprovalText'], // 待审批
  ['3', 'AwaitingProcessingText'], // 待处理
  ['4', 'ProgressText'], // 处理中
  ['6', 'NotApprovedText'], // 审批不通过
]);
/** 工单 --> 工单列表tab页 -----》  User端 */
export const CSG_WORK_ORDER_LIST_USER_CLOSE = F([
  ['0', 'wholeText'], // 全部
  ['5', 'CompletedText'], // 已处理
  ['7', 'CancelledText'], // 已作废
]);
/** 工单 --> 工单状态 -----》  CSG新 */
export const CSG_WORK_ORDER_STATUS_ADMIN = F([
  ['1', 'BillingStatusDRAFT'], // 草稿
  ['2', 'ApprovalText'], // 待审批
  ['3', 'PendingText'], // 待处理
  ['4', 'ProgressText'], // 处理中
  ['5', 'processedText'], // 已处理
  ['6', 'NotApprovedText'], // 审批不通过
  ['7', 'voidedText'], // 已作废
  ['8', 'tombstoneText'], // 逻辑删除
  ['9', 'ConfirmationPending'], // 待确认
]);


export const CSG_rateCalculato_STATUS_ADMIN = F([
  [false, 'ProgressText'], // 处理中
  [true, 'PurchaseCompletedText'], // 已完成
]);

export const SendEmail_STATUS_ADMIN = F([
  ["1", 'GeneralemailText'], // 处理中
  ["2", 'BillingEmailText'], // 已完成
  ["3", 'CustomerServiceEmailText'], // 已完成
]);
/** 工单 --> 工单状态 -----》  CSG新 */
export const CSG_WORK_ORDER_STATUS_USER = F([
  ['1', 'BillingStatusDRAFT'], // 草稿
  ['2', 'ApprovalText'], // 待审批
  ['3', 'PendingText'], // 待处理
  ['4', 'ProgressText'], // 处理中
  ['5', 'processedText'], // 已处理
  ['6', 'NotApprovedText'], // 审批不通过
  ['7', 'voidedText'], // 已作废
  ['8', 'tombstoneText'], // 逻辑删除
  ['9', 'processedText'], // 已处理
]);
/** 工单 --> 紧急程度 -----》  CSG新 */
export const CSG_WORK_ORDER_EXIGENCY = F([
  [0, 'ordinaryText'], // 普通
  [1, 'urgentText'], //   紧急
]);
/** 工单 --> 处理结果 -----》  CSG新 */
export const CSG_WORK_ORDER_HANDLERESULT = F([
  ['Operation Has Been Completed.', 'Operation Has Been Completed.'], 
  ['Other', 'Other'], 
]);
/** 工单 --> 是否暂停 -----》  CSG新 */
export const CSG_WORK_ORDER_PAUSE = F([
  [0, 'NotPausedText'], // 未暂停
  [1, 'PausedText'], //   已暂停
]);
/** 工单 --> 审核结果 -----》  CSG新 */
export const CSG_WORK_ORDER_REVIEW = F([
  [0, 'auditPassText'], // 通过
  [1, 'auditNotPassText'], //   不通过
  [2, 'DesignatedDepartmentText'], // 指定部门
]);
/** 内部销售O2O订单 --> O2O 订单聚合状态 */
export const ORDER_INTERNAL_O2O_STATUS_LIST = F([
  ['11', 'tobeReviewedText'],
  ['22', 'ReceiptToBeConfirmedText'],
  ['33', 'completedText'],
]);
// 收费策略 激活状态
export const ORDER_ACTIVE_TYPE = F([
  ['ACTIVE', 'ACTIVEText'],
  ['UNACTIVE', 'UNACTIVEText'],
]);

/** 三方销售单 --> 订单聚合状态  取自内部单，文字修改 */
export const ORDER_THIRD_ORDER_STATUS_LIST = F([
  ['0', 'ToBeShippedText'],
  ['1', 'completedText'],
  ['2', 'ClosedText'],
  ['3', 'unusualText'],
]);
// 内部销售单 --> 寻源前tobeReviewedText状态
export const ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_SOURCE = F([
  // #ifndef OPEN-SOURCE
  ['30211,30221,30213,30223', 'wholeText'],
  ['30211', 'PendingFirstTrialText'],
  ['30221', 'PendingSecondReviewText'],
  ['30213,30223', 'auditRejectText'],
  // #endif
]);
// 内部销售单 --> 发货前tobeReviewedText状态
export const ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_PREEMPT = F([
  ['30411,30421,30413,30423', 'wholeText'],
  ['30411', 'PendingFirstTrialText'],
  ['30421', 'PendingSecondReviewText'],
  ['30413,30423', 'auditRejectText'],
]);
// 内部普通销售单 --> 审核权限； 与 路由表 对应
export const ORDER_INTERNAL_ORDER_AUDIT_PERMISSION_RULES = [
  // #ifndef OPEN-SOURCE
  // 寻源前
  [
    // 全部
    ['BusinessOrderAuditIndex_SourceFirst', 'BusinessOrderAuditIndex_SourceSecond'],
    // 待一审
    ['BusinessOrderAuditIndex_SourceFirst'],
    // 待二审
    ['BusinessOrderAuditIndex_SourceSecond'],
    // auditRejectText
    ['BusinessOrderAuditIndex_ItIsAwayNot'],
  ],
  // #endif
  // 发货前
  [
    // 全部
    ['BusinessOrderAuditIndex_PreemptFirst', 'BusinessOrderAuditIndex_PreemptSecond'],
    // 待一审
    ['BusinessOrderAuditIndex_PreemptFirst'],
    // 待二审
    ['BusinessOrderAuditIndex_PreemptSecond'],
    // auditRejectText
    ['BusinessOrderAuditIndex_ItIsAwayNot'],
  ],
];
// 内部o2o销售单 --> 审核权限； 与 路由表 对应
export const ORDER_INTERNAL_O2O_AUDIT_PERMISSION_RULES = [
  [
    // 全部
    ['BusinessO2oAuditIndex_First', 'BusinessO2oAuditIndex_Second'],
    // 待一审
    ['BusinessO2oAuditIndex_First'],
    // 待二审
    ['BusinessO2oAuditIndex_Second'],
    // auditRejectText
    ['BusinessOrderAuditIndex_ItIsAwayNot'],
  ],
];
/** 订单 —— 预占状态 */
export const ORDER_INTERNAL_PREEMPT_STATUS_LIST = F([
  ['30101', 'AllToBeReservedText'],
  ['30102', 'AllPreOccupiedSuccessfullyText'],
  ['30103', 'FailedToPreOccupyAllText'],
  ['30104', 'PartialPreoccupationText'],
  ['31010', 'CancelPreemptionText'], // 订单取消时，预占也同时取消，状态码与订单取消状态相同
]);
export const ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST = F([
  ['20101', 'AllToBeReservedText'],
  ['20102', 'AllPreOccupiedSuccessfullyText'],
  ['20103', 'FailedToPreOccupyAllText'],
  ['20104', 'PartialPreoccupationText'],
  ['21010', 'CancelPreemptionText'], // 订单取消时，预占也同时取消，状态码与订单取消状态相同
]);
export const ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST = F([
  ['10101', 'ToBeReservedText'],
  ['10102', 'PreoccupiedSuccessfullyText'],
  ['10103', 'PreemptionFailedText'],
  ['10122', 'UnoccupiedSuccessfullyText'],
  ['11010', 'CancelPreemptionText'], // 订单取消时，预占也同时取消，状态码与订单取消状态相同
]);
// 预占管理-预占状态
export const ORDER_ADVANCE_PREEMPT_STATUS_LIST = F([
  [0, 'AllToBeReservedText'],
  [1, 'AllPreOccupiedSuccessfullyText'],
  [3, 'FailedToPreOccupyAllText'],
  [2, 'PartialPreoccupationText'],
  [4, 'CancelPreemptionText'],
]);
/** 订单 —— 预占回写状态 */
export const ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST = F([
  ['30111', 'AllToBeWrittenBackText'],
  ['30112', 'WriteBackAllSucceededText'],
  ['30113', 'FailedToWriteBackAllText'],
  ['30114', 'PartialWritebackText'],
]);
export const ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST = F([
  ['20111', 'AllToBeWrittenBackText'],
  ['20112', 'WriteBackAllSucceededText'],
  ['20113', 'FailedToWriteBackAllText'],
  ['20114', 'PartialWritebackText'],
]);
export const ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST = F([
  ['10111', 'ToBeWrittenBackText'],
  ['10112', 'WriteBackSucceededText'],
  ['10113', 'WriteBackFailedText'],
]);
/** 订单 —— 寻源状态 */
export const ORDER_INTERNAL_SOURCE_STATUS_LIST = F([
  // #ifndef OPEN-SOURCE
  ['30301', 'AllSourcesToBeSoughtText'],
  ['30302', 'AllSourcingSucceededText'],
  ['30303', 'AllSourcingFailedText'],
  ['30304', 'PartialSourcingText'],
  ['30305', 'CancelSourcingText'],
  // #endif
]);
export const ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST = F([
  // #ifndef OPEN-SOURCE
  ['20301', 'AllSourcesToBeSoughtText'],
  ['20302', 'AllSourcingSucceededText'],
  ['20303', 'AllSourcingFailedText'],
  ['20304', 'PartialSourcingText'],
  ['20305', 'CancelSourcingText'],
  // #endif
]);
export const ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST = F([
  // #ifndef OPEN-SOURCE
  ['10301', 'SourceToBeBoughtText'],
  ['10302', 'SourcingSucceededText'],
  ['10303', 'SourcingFailedText'],
  ['10305', 'CancelSourcingText'],
  // #endif
]);
/** 订单 —— 发货状态 */
export const ORDER_INTERNAL_DELIVER_STATUS_LIST = F([
  ['30510', 'initialText'],
  ['30511', 'AllToBeShippedText'],
  ['30512', 'AllShipmentsSucceededText'],
  ['30513', 'FailedToShipAllText'],
  ['30514', 'PartialShipmentText'],
]);
export const ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST = F([
  ['20510', 'initialText'],
  ['20511', 'AllToBeShippedText'],
  ['20512', 'AllShipmentsSucceededText'],
  ['20513', 'FailedToShipAllText'],
  ['20514', 'PartialShipmentText'],
]);
//  0未推送 1已推送 2已发货 3已取消 6待取消 7取消失败
export const SAP_ORDER_STATUS_LIST = F([
  [0, 'Not Pushed'],
  [1, 'Pushed'],
  [2, 'Shipped'],
  [3, 'Canceled'],
  [6, 'Pending Cancellation'],
  [7, 'Cancellation Failed'],
]);
// 0未锁定 1已锁定 2已发货
export const HJ_ORDER_STATUS_LIST = F([
  [0, 'Not Locked'],
  [1, 'Locked'],
  [2, 'Shipped']
]);
export const ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST = F([
  ['10510', 'initialText'],
  ['10511', 'ToBeShippedText'],
  ['10512', 'ShipmentSucceededText'],
  ['10513', 'ShipmentFailedText'],
]);
/** 订单 —— 收货状态 */
export const ORDER_INTERNAL_RECEIVING_STATUS_LIST = F([
  ['30520', 'initialText'],
  ['30521', 'GoodsToBeReceivedText'],
  ['30522', 'AllReceivedText'],
  ['30523', 'PartialReceiptText'],
]);
export const ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST = F([
  ['20520', 'initialText'],
  ['20521', 'GoodsToBeReceivedText'],
  ['20522', 'AllReceivedText'],
  ['20523', 'PartialReceiptText'],
]);
export const ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST = F([
  ['10520', 'initialText'],
  ['10521', 'GoodsToBeReceivedText'],
  ['10522', 'ReceivedText'],
]);
/** 订单 —— 库存回写状态 */
export const ORDER_INTERNAL_STOCK_BACK_STATUS_LIST = F([
  ['30531', 'AllToBeWrittenBackText'],
  ['30532', 'WriteBackAllSucceededText'],
  ['30533', 'FailedToWriteBackAllText'],
  ['30534', 'PartialWritebackText'],
]);
export const ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST = F([
  ['20531', 'AllToBeWrittenBackText'],
  ['20532', 'WriteBackAllSucceededText'],
  ['20533', 'FailedToWriteBackAllText'],
  ['20534', 'PartialWritebackText'],
]);
export const ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST = F([
  ['10531', 'ToBeWrittenBackText'],
  ['10532', 'WriteBackSucceededText'],
  ['10533', 'WriteBackFailedText'],
]);
/** 客户 —— 入场客户审批状态 **/
export const USER_ONBOARDING_STAGE_LIST = F([
  ['request', 'STAGE_LIST1'],
  ['docs', 'STAGE_LIST2'],
  ['finance', 'STAGE_LIST3'],
  ['account', 'STAGE_LIST4'],
  ['checklist', 'STAGE_LIST5'],
  ['erp', 'STAGE_LIST6'],
  ['it', 'STAGE_LIST7'],
  ['final', 'STAGE_LIST8'],
  ['finish', 'STAGE_LIST9'],
]);
export const USER_CUSTOMER_TYPE_LIST = F([
  ['1', 'nonStandardUserText'],
  ['2', 'standardUserText'],
]);
export const USER_ONBOARDING_INDUSTRY_LIST = F([
  [1, 'Small Items'],
  [2, 'Electronics'],
  [3, '2C in General'],
  [4, 'Furniture'],
  [5, 'Rice Cook Whole Sale'],
  [6, 'BikeRacks'],
  [7, 'Car Toys'],
  [8, '2B in General'],
  [9, 'Drinks'],
  [10, 'Small Toys Whole Sale'],
]);

/** 订单 —— 挂起状态 */
export const ORDER_INTERNAL_HAND_UP_STATUS_LIST = F([
  ['31200', 'NotPendingText'],
  ['31201', 'AllSuspendedSuccessfullyText'],
  ['31202', 'FailedToSuspendAllText'],
  ['31203', 'PartialPendingText'],
]);
/** 订单 —— 订单状态  totalOrderStatus： 1新订单、2异常、3处理中、4缺货、7等待取货 */
export const ORDER_INTERNAL_NO_STATUS_LIST = F([
  [1, 'OrderAllStatusNEWText'],
  [2, 'OrderAllStatusErrorText'],
  [3, 'OrderAllStatusProcessingText'],
  [4, 'OrderAllStatusOutofStockText'],
  [7, 'OrderAllStatusCollectText'],
  [8, 'BusinessAbnormalOrderWAIRING'],
]);
/** 订单 —— 订单状态  totalOrderStatus： 5完成、6取消 */
export const ORDER_INTERNAL_YES_STATUS_LIST = F([
  [5, 'completedText'],
  [6, 'canceledText'],
]);
/** 订单 —— 订单状态  totalOrderStatus： 5完成、6取消 */
export const ORDER_INTERNAL_HUNT_STATUS_LIST = F([
  ['3', 'ClosedText'],
  ['9', 'UNClosedText'],
]);
/** 订单 —— 订单总状态  totalOrderStatus： 1新订单、2异常、3处理中、4缺货，5完成、6取消,7等待取货 ,8等待发货*/
export const ORDER_INTERNAL_ALL_STATUS_LIST = F([
  [1, 'OrderAllStatusNEWText'],
  [2, 'OrderAllStatusErrorText'],
  [3, 'OrderAllStatusProcessingText'],
  [4, 'OrderAllStatusOutofStockText'],
  [5, 'completedText'],
  [6, 'canceledText'],
  [7, 'OrderAllStatusCollectText'],
  [8, 'BusinessAbnormalOrderWAIRING'],
]);
export const ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST = F([
  ['21200', 'NotPendingText'],
  ['21201', 'AllSuspendedSuccessfullyText'],
  ['21202', 'FailedToSuspendAllText'],
  ['21203', 'PartialPendingText'],
]);
export const ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST = F([
  ['11210', ''],
  ['11200', 'NotPendingText'],
  ['11211', 'SystemSuspendedSuccessfullyText'],
  ['11212', 'SystemSuspendFailedText'],
  ['11213', 'SystemDecouplingSucceededText'],
  ['11214', 'SystemDecouplingFailedText'],
  ['11221', 'SuccessfullySuspendedManuallyText'],
  ['11222', 'ManualSuspendFailedText'],
  ['11223', 'ManualDecouplingSucceededText'],
  ['11224', 'ManualDecouplingFailedText'],
]);

export const PURCHASE_STATUS_LIST = F([
  ['WAIT_FIRST_AUDIT', 'PurchaseWaitFirstAuditText'],
  ['FIRST_AUDIT_REJECTED', 'PurchaseFirstAuditRejectedText'],
  ['WAIT_SECOND_AUDIT', 'PurchaseWaitSecondAuditText'],
  ['SECOND_AUDIT_REJECTED', 'PurchaseSecondAuditRejectedText'],
  ['WAIT_THIRD_AUDIT', 'PurchaseWaitThirdAuditText'],
  ['THIRD_AUDIT_REJECTED', 'PurchaseThirdAuditRejectedText'],
  ['COMPLETED', 'PurchaseCompletedText'],
  ['CANCELLED', 'PurchaseCancelledText'],
  ['WAIT_PURCHASE', 'PurchaseWaitPurchaseText'],
]);
export const QUOTATION_STATUS_LIST = F([
  ['WAIT_FIRST_AUDIT', 'PurchaseWaitFirstAuditText'],
  ['FIRST_AUDIT_REJECTED', 'PurchaseFirstAuditRejectedText'],
  ['WAIT_SECOND_AUDIT', 'PurchaseWaitSecondAuditText'],
  ['SECOND_AUDIT_REJECTED', 'PurchaseSecondAuditRejectedText'],
  ['WAIT_THIRD_AUDIT', 'PurchaseWaitThirdAuditText'],
  ['THIRD_AUDIT_REJECTED', 'PurchaseThirdAuditRejectedText'],
  ['COMPLETED', 'PurchaseCompletedText'],
  ['CANCELLED', 'PurchaseCancelledText'],
  ['WAIT_PURCHASE', 'PurchaseWaitPurchaseText'],
  ['DRAFT', 'PurchaseDraftText'],
]);
export const PURCHASELIST_STATUS_LIST = F([
  ['WAIT_PRODUCED', 'PurchaseWaitCreateText'],
  ['IN_PROD', 'PurchaseProducingText'],
  ['COMPLETED', 'PurchaseCompletedText'],
  ['CANCELLED', 'PurchaseCancelledText'],
  ['FAIL_PUSH_SAP', 'PurchaseSecondAuditRejectedText'],
]);
export const IGNORE_AUDIT_STATUS_LIST = F([
  ['WAIT_FIRST_AUDIT', 'tobeReviewedText'],
  ['FIRST_AUDIT_REJECTED', 'auditRejectText'],
  ['COMPLETED', 'completedText'],
]);

/** 审核状态 */
export const ORDER_INTERNAL_AUDIT_STATUS_LIST = F([
  [30211, 'PendingFirstTrialText'],
  [30221, 'PendingSecondReviewText'],
  [30212, 'PassedInTheFirstInstanceText'],
  [30222, 'PassedInTheSecondInstanceText'],
  [30213, 'FailToPassTheFirstInstanceText'],
  [30223, 'FailTheSecondInstanceText'],

  [30411, 'PendingFirstTrialText'],
  [30421, 'PendingSecondReviewText'],
  [30412, 'PassedInTheFirstInstanceText'],
  [30422, 'PassedInTheSecondInstanceText'],
  [30413, 'FailToPassTheFirstInstanceText'],
  [30423, 'FailTheSecondInstanceText'],
]);
/** 支付方式 */
export const ORDER_INTERNAL_PAYMENT_LIST = F([
  ['alipay', 'AlipayText'],
  ['qq', 'QQPaymentText'],
  ['weixin', 'WeChatpaymentText'],
  ['tenpay', 'TenpayText'],
  ['lianlianpay', 'ContinuousPaymentText'],
  ['chinabank', 'OnlineBankingText'],
  ['cod', 'cashOnDeliveryText'],
  ['bank', 'BankRemittanceTransferText'],
  ['other', 'otherText'],
]);
/** 支付状态 */
export const ORDER_INTERNAL_PAYMENT_STATUS_LIST = F([
  [0, 'UnpaidText'],
  [1, 'PaidText'],
]);

/* ************************************** 内部销售单 end ****************************************** */

/* ************************************** 内部售后单 start ****************************************** */
/** 退款单类型 */
export const INTERNAL_AFTER_REFUND_ORDER_TYPE_LIST = F([[0, 'GeneralChargebackText']]);

/** 退款类型 */
export const INTERNAL_AFTER_REFUND_TYPE_LIST = F([[1, 'RefundOnlyIfNotShippedText']]);
export const INTERNAL_AFTER_RETURN_TYPE_LIST = F([[1, 'ReturnRefundText']]);
/** 售后阶段 */
export const INTERNAL_AFTER_STAGE_STATUS = F([
  [0, 'OnSaleText'],
  [1, 'AfterSalesText'],
]);
/** 退货原因 */
export const INTERNAL_AFTER_REASON_STATUS = F([[0, 'ReturnWithoutReasonWithin7DaysText']]);
/* ************************************** 内部售后单 end ****************************************** */
/* ************************************** 三方销售单 start ****************************************** */
/** 支付状态 */
export const ORDER_THIRD_PAYMENT_STATUS_LIST = F([[1, 'PaidText']]);
/** 平台收货状态 */
export const ORDER_THIRD_RECEIVING_STATUS_LIST = F([
  [0, 'UnreceivedGoodsText'],
  [1, 'ReceivedText'],
]);
/** 流转状态 */
export const ORDER_THIRD_CIRCULATION_STATUS_LIST = F([
  [0, 'normalText'],
  [1, 'unusualText'],
  [2, 'PendingText'],
]);
// 详情、商品： 异常标识：0-正常，1-异常
export const ORDER_THIRD_EXCEPTION_FLAG_LIST = F([
  [0, 'normalText'],
  [1, 'unusualText'],
  [2, 'PendingText'],
]);

/** 平台状态 */
export const ORDER_THIRD_PLATFORM_STATUS_LIST = F([
  [0, 'NotClosedText'],
  [1, 'tradedText'],
  [2, 'canceledText'],
]);
/** 退款状态 */
export const ORDER_THIRD_REFUND_STATUS_LIST = F([
  [1, 'NoAfterSalesServiceText'],
  [2, 'AfterSalesProcessingText'],
  [3, 'RefundingText'],
  [4, 'RefundSucceededText'],
]);
/** 订单来源 */
export const ORDER_THIRD_ORDERSOURCE_STATUS_LIST = F([
  [1, 'InterfaceGrabText'],
  [2, 'ManualDocumentCreationText'],
  [3, 'EXCELImportText'],
]);
/** 发票类别 */
export const ORDER_THIRD_INVOICE_STATUS_LIST = F([[0, 'NoInvoicingRequiredText']]);
/** 物流方式 */
export const ORDER_THIRD_SHIPPING_TYPE_LIST = F([[0, 'SellerPackageText']]);
/** 订单解密枚举 */
export const ORDER_DECRYPT_NAME = {
  receiverNameMask: 'receiverName',
  receiverPhoneMask: 'receiverPhone',
  addressMask: 'receiverAddress',
};

/* ************************************** 三方销售单 end ****************************************** */
/* ************************************** 出库通知单 start ****************************************** */
export const ORDER_STOCK_OUT_TYPE_LIST = F([
  [0, 'ToBeNotifiedWMSText'],
  [1, 'ToBeDeliveredText'],
  [2, 'FailedToNotifyWMSText'],
  [3, 'AllOutboundText'],
  [4, 'PartialDeliveryText'],
  [5, 'CancelIssueText'],
]);
/* ************************************** 出库通知单 end ****************************************** */

/* ************************************** 出库结果单 start ****************************************** */
export const ORDER_STOCK_RESULT_STATUS_LIST = F([[0, 'AllOutboundText']]);
/* ************************************** 出库结果单 end ****************************************** */

/* ************************************** 销售审核策略 start ****************************************** */
/** 销售审核策略 router */
export const STRATEGY_MARKETINGAUDIT_ROUTE_LIST = F([
  ['SettingOrderAuditStrategy', '订单审核策略'],
  ['SettingOrderAuditGoods', '订单商品行审核策略'],
]);
/* ************************************** 销售审核策略 end ****************************************** */
/* ************************************** 财务管理 对账 start ****************************************** */
export const FINANCE_ORIGINAL_ROUTE_LIST = F([
  ['BusinessFinancePlatformOriginalTmallIndex', '天猫账单'],
  ['BusinessFinancePlatformOriginalJdcomIndex', '京东账单'],
]);
// 解析状态
export const FINANCE_PLATFORM_PARSING_STATUS = F([
  [0, 'ParsingSucceededText'],
  [1, 'NoParsingRequiredText'],
]);
// 对账状态
export const FINANCE_PLATFORM_CHECKING_STATUS = F([
  [0, 'ReconciledText'],
  [1, 'UnreconciledText'],
  [2, 'NoReconciliationRequiredText'],
]);
// 业务类型
export const FINANCE_PLATFORM_BUSINESS_TYPES = F([
  [0, 'paymentForGoodsText'],
  [1, 'commissionText'],
]);
// 流水类型
export const FINANCE_PLATFORM_FLOW_TYPES = F([
  ['0', 'OrthocurrentWaterText'],
  ['1', 'NegativeCurrentText'],
]);
// 业务中心-财务管理-对账管理-已对账列表 状态
export const FINANCE_CHECKING_CHECKED_STATUS = F([
  [true, 'ReconciledText'],
  [false, 'AmountAbnormalityText'],
]);
// 财务管理-对账管理-物流对账  物流状态
export const FINANCE_CHECKING_LOGISTIC_SIGN_STATUS = F([
  [0, 'SignedForText'],
  [1, 'ReturnedText'],
  [2, 'visaRejectedText'],
]);
// 财务管理-对账管理-物流对账  结算状态
export const FINANCE_CHECKING_LOGISTIC_SETTLE_STATUS = F([
  [0, 'SettledText'],
  [1, 'UnsettledText'],
]);
// 财务管理-对账管理-物流对账  tab
export const FINANCE_CHECKING_LOGISTIC_COST_DETAIL_TYPES = F([
  [null, 'DetailsOfAllExpensesText'],
  ['1', 'MatchingFeeDetailsText'],
  ['2', 'UnMatchingFeeDetailsText'],
]);
// 财务管理-对账管理-物流对账  匹配状态
export const FINANCE_CHECKING_LOGISTIC_MATCHING_TYPES = F([
  [0, 'mateText'],
  [1, 'MatchingAmountText'],
  [2, 'mismatchingText'],
]);
// 财务管理-对账管理-物流对账-内部物流单列表  费用确认状态
export const FINANCE_CHECKING_LOGISTIC_COST_CONFIRM_STATUS = F([
  [0, 'ConfirmedText'],
  [1, 'UnconfirmedText'],
  [2, 'AmountDifferenceText'],
]);
/* ************************************** 财务管理 对账 end ****************************************** */

/* ************************************** 财务管理 平台账单解析策略设置  Start ****************************************** */
// 账单类型
export const FINANCE_PARSESTRATEGY_BULL_TYPES = F([
  [0, 'salesRevenueText'],
  [1, 'refundExpensesText'],
]);
// 金额取值
export const FINANCE_PARSESTRATEGY_PRICE_VALUE_TYPES = F([
  [0, 'GetFixedFieldsText'],
  [1, 'calculateAccordingToTheFormulaText'],
]);
/* ************************************** 财务管理 平台账单解析策略设置  end ****************************************** */

/* ************************************** 财务管理 结算 Start ****************************************** */
// 财务管理-结算管理-结算列表  订单类型
export const FINANCE_SETTLEMENT_ORDER_TYPES = F([
  [0, 'SalesOrderText'],
  [1, 'RefundOrderText'],
  [2, 'ReturnAndRefundOrderText'],
  [3, 'ExchangeOrderText'],
]);
// 财务管理-结算管理-结算列表  售后单类型
export const FINANCE_SETTLEMENT_AFTER_TYPES = F([
  [1, 'RefundOrderText'],
  [2, 'ReturnAndRefundOrderText'],
  [3, 'ExchangeOrderText'],
]);
// 财务管理-结算管理-结算列表  状态
export const FINANCE_SETTLEMENT_UNSETTLED_STATUS = F([
  [0, 'ConfirmedText'],
  [1, 'UnconfirmedText'],
]);
// 财务管理-结算管理-结算列表  生成方式
export const FINANCE_SETTLEMENT_UNSETTLED_CREATE_TYPES = F([
  [0, 'handMovementText'],
  [1, 'voluntarilyText'],
]);
// 财务管理-结算管理-未结算列表  对账状态
export const FINANCE_SETTLEMENT_UNSETTLED_CHECKED_STATUS = F([
  [true, 'normalText'],
  [false, 'unusualText'],
]);

// 结算管理-策略配置-结算策略配置-订单结算策略-新增 - 满足条件
export const FINANCE_SETTLEMENT_STRATEGY_ORDER_CONDITIONS = F([
  ['all', 'MeetsAllOfTheFollowingConditionsText'],
  ['one', 'MeetsAnyOfTheFollowingConditionsText'],
]);
// 结算管理-策略配置-结算策略配置-订单结算策略-新增 - 满足条件
export const FINANCE_SETTLEMENT_STRATEGY_ORDER_CONDITION_TYPES = F([
  [0, 'Sales Channel'], [1, 'Order Source'], [2, 'Order Type'], [3, 'Order Flag'],

  [0, 'SalesChannelText'],
  [1, 'OrderSourceText'],
  [2, 'OrderTypeText'],
  [3, 'OrderFlagText'],
]);
// 结算管理-策略配置-结算策略配置-订单结算策略-新增 - 订单来源
export const FINANCE_SETTLEMENT_STRATEGY_ORDER_SOURCE = F([
  [0, 'ThirdPartyPlatformDownloadText'],
  [1, 'ManuallyCreatedText'],
  [2, 'FileImportText'],
]);
// 结算管理-策略配置-结算策略配置-订单结算策略-新增 - 订单来源
export const FINANCE_SETTLEMENT_STRATEGY_ORDER_TAGS = F([
  [0, 'stockoutText'],
  [1, 'unusualText'],
]);
// 结算管理-策略配置-结算策略配置-订单结算策略-新增 - 触发节点
export const FINANCE_SETTLEMENT_STRATEGY_ORDER_NODES = F([
  [0, 'OrderCompletedText'],
  [1, 'ShipmentCompletedText'],
]);
// 结算管理-策略配置-结算策略配置-售后单结算策略-新增
export const FINANCE_SETTLEMENT_STRATEGY_AFTER_CONDITION_TYPES = F([
  [0, 'AfterSalesChannelText'],
  [1, 'AfterSalesOrderSourceText'],
  [2, 'AfterSalesOrderTypeText'],
]);
// 结算管理-策略配置-结算策略配置-售后单结算策略-新增 - 触发节点
export const FINANCE_SETTLEMENT_STRATEGY_AFTER_NODES = F([
  [0, 'AfterSalesCompletedText'],
  [1, 'AuditCompletedText'],
]);
/* ************************************** 财务管理 结算 end ****************************************** */
/* ************************************** 业务中心-营销管理-营销商品管理 Start ****************************************** */
export const MARKETING_COMMODITY_MANAGEMENT_STATUS = F([
  [0, 'NotStartedText'],
  [1, 'InProgressText'],
  [2, 'EndedText'],
  [3, 'TerminatedText'],
]);
export const MARKETING_COMMODITY_MANAGEMENT_TIME_TYPES = F([
  [0, 'ThirdPartyOrderTimeText'],
  [1, 'PaymentTimeText'],
]);
export const MARKETING_COMMODITY_MANAGEMENT_GIFT_STORE_TYPES = F([
  [1, 'AllStoresText'],
  [0, 'SpecifiedStoresText'],
]);
export const MARKETING_COMMODITY_MANAGEMENT_GIFT_GOODS_TYPES = F([
  [1, 'AllProductsInStoreText'],
  [0, 'SpecifiedProductsText'],
]);
/** 赠送条件 */
export const MARKETING_COMMODITY_MANAGEMENT_GIFT_TYPES = F([
  // [0, '满元赠'],
  [1, 'FullGiftText'],
]);
/* ************************************** 业务中心-营销管理-营销商品管理 end ****************************************** */
/* ************************************** 业务中心-标签管理-系统标签 Start ****************************************** */
// 标签类型
export const LABEL_SYS_TYPES = F([
  [0, 'ManualOrderText'],
  [1, 'CopyOrderText'],
  [2, 'ReissueOrderText'],
  [3, 'ReturnOrderText'],
  [4, 'RefundNoteText'],
  [5, 'ExchangeOrderText'],
  [6, 'OrderOutOfStockText'],
  [7, 'OrderExceptionText'],
  [8, 'MarketingProductsText'],
  [9, 'PurchaseOrdersText'],
]);
// BjTag 组件的样式
export const LABEL_HAND_COLORS = F([
  // [ value ,   name  ],
  ['orange', 'orange橙色'],
  ['yellow-dark', 'yellow-dark暗黄'],
  ['purple-light', 'purple-light淡紫'],
  ['brown-light', 'brown-light淡棕'],
  ['blue-purple', 'blue-purple蓝紫'],
  ['blue-light', 'blue-light淡蓝'],
  ['green-light', 'green-light淡绿'],
  ['orange-red', 'orange-red橘黄'],
]);

/* ************************************** 业务中心-标签管理-系统标签 end ****************************************** */

// 商品中心-分类管理-类型
export const GOODS_CLASSIFY_TYPES = F([
  [false, 'NormalCategoryText'],
  [true, 'LeafCategoryText'],
]);
// 商品中心-属性来源  有  GOODS_ATTRIBUTE_SOURCES_JSON
export const GOODS_ATTRIBUTE_SOURCES = F([
  [0, 'NewText'], // 商品属性
  [1, 'SystemDefaultText'],
  [2, 'ParentCategoryText'], // 分类属性
  [3, 'AdditionalAttributeText'],
]);
// SKU 的 属性 分类
export const GOODS_ATTRIBUTE_TYPES = F([
  [0, 'ProductAttributeText'],
  [1, 'SystemDefaultText'],
  [2, 'CategoryAttributeText'],
  [3, 'AdditionalAttributeText'],
]);

export const BPMN_STATUS_LIST = F([
  [0, 'NotDeployedText'],
  [1, 'DeployedText'],
]);
export const SETTING_PERMISSION_TYPE_LIST = F([
  ['api', 'MenuText'],
  ['btn', 'ButtonText'],
  ['page', 'PageText'],
  ['tab', 'TabText'],
]);
export const SETTING_PERMISSION_TYPE_COLOR_LIST = F([
  ['api', 'info'],
  ['btn', 'warning'],
  ['tab', 'danger'],
  ['page', 'success'],
]);
export const ENDORSE_STATUS_LIST = F([
  ['0', 'tobeReviewedText'],
  ['1', 'ReviewedText'],
]);
/**                              报表管理                                       */
export const BUSINESS_REPORT_SALE_ROUTE_LIST = F([
  ['BusinessReportSaleCensusIndex', '销售统计表'],
  ['BusinessReportSaleAnalysisIndex', '销售分析表'],
  ['BusinessReportSaleGoodsIndex', '销售商品统计表'],
  ['BusinessReportSaleShopIndex', '店铺销售表'],
]);
export const BUSINESS_ORDER_TIMELINESS = F([
  ['BusinessOrderTimelinessAverage', '处理时长表'],
  ['BusinessOrderTimelinessOnTime', '按时处理率表'],
]);
export const BUSINESS_WAREHOUSE_EFFICIENCY = F([
  ['BusinessOrderWarehousePickerRank', '处理时长表'],
  ['BusinessOrderrWarehouseForkliftDriver', '按时处理率表'],
]);
export const BUSINESS_REPORT_STOCK_ROUTE_LIST = F([
  ['BusinessReportStockDeliverIndex', '发货汇总表'],
  ['BusinessReportStockOutIndex', '缺货统计表'],
]);
/** BI销售报表 */
export const BUSINESS_SALE_DAILY_ROUTE_LIST = F([
  ['BusinessBIReportCSGProfitAnalysisReport', 'CSG Profit Analysis Report'],
  ['BusinessBIReportTicketCompletionPerformanceReport', 'Ticket Completion Performance Report'],
  ['BusinessBIReportWarehousePerformanceReport', 'Warehouse Performance Report'],
  ['BusinessBIReportProfitAnalysisReport', 'Profit Analysis Report'],
]);
export const REPORT_SALE_STATISTICS_TIME_LIST = F([
  [1, 'ByThirdPpartyOrderTimeText2'],
  [2, 'ByInternalCreationTimeText'],
]);
export const REPORT_SALE_STATISTICS_TIME_LIST2 = F([
  [1, 'ByThirdPpartyOrderTimeText'],
  [2, 'ByInternalCreationTimeText'],
]);
export const REPORT_SALE_STATISTICS_SUMMARY_LIST = F([
  [1, 'ByChannelText'],
  [2, 'ByMonthText'],
  [3, 'ByRegionText'],
]);
/** 网店授权状态 */
export const CHANNEL_ONLINE_CREDIT_STATUS = F([
  [1, 'UnauthorizedText'],
  [2, 'AuthorizedSuccessfullyText'],
  [3, 'AuthorizationInvalidText'],
  [4, 'AuthorizationSuspendedText'],
]);
/* ************************** 三方商品 *********************************/
/** 匹配状态 */
export const THIRD_GOODS_MATCH_STATUS = F([
  [1, 'MatchedSuccessfullyText'],
  [0, 'MatchedFailedText'],
]);
/** 匹配方式 */
export const THIRD_GOODS_MATCH_WAY_STATUS = F([
  [2, 'AutomaticMatchingText'],
  [1, 'ManualMatchingText'],
]);
/** 平台货品状态 */
export const THIRD_GOODS_STATUS = F([
  [1, 'OnShelfText'],
  [0, 'OffShelfText'],
]);
/** 活动状态 */
export const THIRD_GOODS_ACTIVITY_STATUS = F([
  [0, 'NormalProductText'],
  [1, 'PromotionalProductText'],
]);
/**                              报表管理end                                    */
/**
 * 值集管理tabs
 */
export const SETTING_BASE_DATA_LOV_ROUTE_LIST = F([
  ['SettingBaseDataLovIndex', '值集管理'],
  ['SettingBaseDataLovHeaderIndex', '值集头管理'],
]);
/** 通用导入模板类型 */
export const IMPORT_GENERAL_TYPE_LIST = F([['C', 'clientText']]);
export const CHINESE_NUM = ['零', 'oneText', 'twoText ', 'threeText', '四', '五', '六', '七', '八', '九'];
// 面单打印状态
export const LOGISTICS_WAYBILL_PRINT_STATUS__LIST = F([
  [false, 'NotPrintedText'],
  [true, 'PrintedText'],
]);

export const WEEK_LIST = F([
  ['2', 'ChannelManagement.cron.Monday'],
  ['3', 'ChannelManagement.cron.Tuesday'],
  ['4', 'ChannelManagement.cron.Wednesday'],
  ['5', 'ChannelManagement.cron.Thursday'],
  ['6', 'ChannelManagement.cron.Friday'],
  ['7', 'ChannelManagement.cron.Saturday'],
  ['1', 'ChannelManagement.cron.Sunday'],
]);

export const DELIVERY_STATUS = F([
  ['Discard', 'returnOrderStatusAbandonedText'],
  ['Normal', 'normalText']
]);

// 计算燃油 calcFuel 0.是 1.否
export const QUOTATION_CALC_FUEL = F([
  [0, 'yesText'],
  [1, 'noText'],
]);
